import { createContext, useContext, useEffect, useState } from "react";
import translations_eng from "../assets/translations_eng";
import translations_swe from "../assets/translations_swe";
import useLocalStorage from "./useLocalStorage";

const TranslationContext = createContext<{
  language: string;
  setLanguage: (l: string) => void;
  t: typeof translations_eng;
}>({ t: translations_eng, language: "eng", setLanguage: () => {} });
export const useTranslationContext = () => useContext(TranslationContext);

interface TranslationProps {
  children: React.ReactNode;
}

export const Translation = ({ children }: TranslationProps) => {
  const [language, setLanguage] = useLocalStorage("language", "eng");
  const getTranslations = (l: string) => {
    if (l === "swe") {
      return translations_swe;
    } else {
      return translations_eng;
    }
  };
  const [translations, setTranslations] = useState(getTranslations(language));
  useEffect(() => {
    setTranslations(getTranslations(language));
  }, [language]);

  return (
    <TranslationContext.Provider
      value={{ setLanguage, t: translations, language }}
    >
      {children}
    </TranslationContext.Provider>
  );
};
